__webpack_require__.p = "https://freight.rtspro.dev/";